import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Api from '../api/api';
import Loader from '../shared/loader';
import stringHelpers from '../../utilities/stringHelpers';
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';
import { AppliedFilterDisplay } from '../shared/appliedFilterDisplay';
import { OrganisationsFiltersModal } from './filters-modals/organisationsFiltersModal';

function Organisations(props) {
    const [organisations, setOrganisations] = useState(null);

    const [status, setStatus] = useState(null);
    const [city, setCity] = useState(null);
    const [search, setSearch] = useState(null);

    const [cityFilterList, setCityFilterList] = useState(null);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);

    const getOrganisations = function () {
        Api.getOrganisations(
            (data) => setOrganisations(data),
            (error) => console.log(error),
            props.token)
    }

    const setCityList = function () {
        if (organisations !== null) {
            var list = new Array();
            organisations.forEach(organisation => {
                if (!list.includes(organisation.townOrCity)) {
                    list.push(organisation.townOrCity);
                }
            });
            setCityFilterList(list);
        }
    }

    useEffect(() => {
        getOrganisations()
    }, [])

    useEffect(() => {
        setCityList()
    }, [organisations])

    return (
        //need to check role - if not org admin then not show add buttons

        <>
            {!organisations && <Loader />}{organisations && organisations !== null && <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-2 col-sm-auto d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Your Organisations</h5>
                                        </div>
                                        <div className="col-auto ml-auto text-right pl-0 d-flex align-items-center">
                                            <SearchBarWithDebounce onSearchQueryChange={ query => setSearch(query === "" ? null : query) } />
                                            <div className='ml-2'>
                                                <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                            </div>
                                            <Link className="btn btn-success btn-sm ml-2 nowrap" to="/organisation"><i className="fas fa-plus"></i> Add</Link>
                                        </div>
                                    </div>
                                </div>
                                {
                                    showFilterPills && appliedFilters &&
                                    <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                        {
                                            Object.entries(appliedFilters).map(
                                                ([label, value]) => !stringHelpers.isNullOrEmpty(value)
                                                && <div className="mr-2" key={ label }>
                                                    <AppliedFilterDisplay
                                                        label={ label }
                                                        onTextClick={ () => setShowFiltersModal(true) }
                                                        onCloseClick={ closedLabel => {
                                                            if (closedLabel === "City") {
                                                                setCity(null)
                                                            } else if (closedLabel === "Status") {
                                                                setStatus(null)
                                                            }
                                                            setAppliedFilters(prevState => {
                                                                const updatedFilters = { ...prevState }
                                                                updatedFilters[closedLabel] = null
                                                                const hasRemainingFilters = Object.values(updatedFilters).some(value => !stringHelpers.isNullOrEmpty(value))
                                                                return hasRemainingFilters ? updatedFilters : null
                                                            })
                                                        } }
                                                        value={ value }
                                                    />
                                                </div>
                                            )
                                        }
                                        { Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={ () => {
                                            setCity(null)
                                            setStatus(null)
                                            setAppliedFilters(null)
                                        } }>Clear all filters</button> }
                                    </div>
                                }
                                <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                    <thead className="bg-200 text-900">
                                        <tr>
                                            <th>Name</th>
                                            <th>Town/City</th>
                                            <th className="text-center">Status</th>
                                            <th className="text-center">API Access</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {organisations.filter(function (organisation) {
                                            var townOrCity = new String(organisation.townOrCity).toLowerCase();
                                            var name = new String(organisation.name).toLowerCase();
                                            return ((organisation.townOrCity === city || city === null) && (organisation.isActive === status || status === null) && (search === null || townOrCity.search(search.toLowerCase()) !== -1 || name.search(search.toLowerCase()) !== -1) )
                                        }).map((organisation) => {
                                                var url = "/organisation/" + organisation.id;
                                                return (
                                                    <tr>
                                                        <td><Link to={url}><h6 className="mb-0">{organisation.name}</h6></Link></td>
                                                        <td>{organisation.townOrCity}</td>
                                                        <td className="text-center">{organisation.isActive && <><i className="fas fa-check text-success"></i></>}{!organisation.isActive && <><i className="fas fa-times text-danger"></i></>}</td>
                                                        <td className="text-center">{organisation.allowApiAccess && <i className="fas fa-check text-success"></i>}</td>
                                                    </tr>)
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showFiltersModal &&
                    <OrganisationsFiltersModal
                        showModal={ showFiltersModal }
                        handleClose={ () => setShowFiltersModal(false) }
                        handleConfirm={ (draftFilters) => {
                            setCity(draftFilters.city)
                            setStatus(draftFilters.status)
                            setAppliedFilters(draftFilters.appliedFilters)
                            setShowFilterPills(true)
                            setShowFiltersModal(false)
                        } }
                        initialCity={ city }
                        initialStatus={ status }
                        initialAppliedFilters={ appliedFilters }
                        cityFilterList={ cityFilterList ?? [] }
                        key="organisations-filters-modal"
                    />
                }
            </>}
        </>
    )
}

export default Organisations;
